var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CreateOrderForm',{attrs:{"store":"order_retail","withProduct":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }